/**
 * /eric/tasks/$taskId/stage — Delivery Staging (T-053, PR-40, PR-41, US-17).
 *
 * Route config only. Component lives in eric.tasks.$taskId.stage.lazy.tsx
 * (code-split). No loader, beforeLoad, or validateSearch.
 */

import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/eric/tasks/$taskId/stage')({});
